<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">ЭНК</a>
          </li>
          <li>
            <a href="#" @click.prevent="add()">Добавить</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
        <b-field label="Type">
          <b-field>
            <b-select v-model="filters.type_id" placeholder="Filter by Type" @input="pageChange()">
              <option
                v-for="option in types"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearType()">X</button>
            </p>
          </b-field>
        </b-field>
        <b-field label="Group">
          <b-field>
            <b-select v-model="filters.group_id" placeholder="Filter by Group" @input="pageChange()">
              <option
                v-for="option in groups"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearGroup()">X</button>
            </p>
          </b-field>
        </b-field>
        <b-field label="Состояние">
          <b-field>
            <b-select v-model="filters.is_active" placeholder="Filter by State" @input="pageChange()">
              <option
                v-for="option in states"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearState()">X</button>
            </p>
          </b-field>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.order">
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="product_name" label="Product Name" sortable>
            {{ props.row.product_name }}
          </b-table-column>

          <b-table-column field="date" label="Date" sortable>
            {{ props.row.date }}
            <!-- {{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:ss:mm') }} -->
          </b-table-column>

          <b-table-column field="southernmost_latitude" label="Southernmost latitude" sortable>
            {{ props.row.southernmost_latitude }}
          </b-table-column>

          <b-table-column field="westernmost_longitude" label="Westernmost longitude" sortable>
            {{ props.row.westernmost_longitude }}
          </b-table-column>

          <b-table-column field="northernmost_latitude" label="Northernmost latitude" sortable>
            {{ props.row.southernmost_latitude }}
          </b-table-column>

          <b-table-column field="easternmost_longitude" label="Easternmost longitude" sortable>
            {{ props.row.easternmost_longitude }}
          </b-table-column>

          <b-table-column field="description_russian" label="Description Russian" sortable>
            {{ props.row.description_russian }}
          </b-table-column>

          <b-table-column field="group" label="Group" sortable>
            <a href="#" @click="applyGroup(props.row.group_id)">
              <b-tag type="is-dark">{{ humanGroup(props.row.group_id) }}</b-tag>
            </a>
          </b-table-column>

          <b-table-column field="type_id" label="Type" sortable>
            <a href="#" @click="applyType(props.row.type_id)">
              <b-tag type="is-dark">{{ humanType(props.row.type_id) }}</b-tag>
            </a>
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block">
              <a href="#" @click="editRow(props.row.id)" style="margin-right: .35rem;">
                <b-icon icon="pen" type="is-dark" size="is-small"></b-icon>
              </a>
              <a href="#" @click="showRow(props.row)" style="margin-right: .35rem;">
                <b-icon icon="map" type="is-dark" size="is-small"></b-icon>
              </a>
              <a href="#" v-if="props.row.is_active == true" @click="dropRow(props.row.id)">
                <b-icon icon="trash" type="is-danger" size="is-small"></b-icon>
              </a>
            </div>
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon
                  icon="sad-tear"
                  size="is-large">
                </b-icon>
              </p>
              <p>Данных нет.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
  </div>
</template>

<script>
import { EventBus } from '@/utils'
export default {
  name: "ProductTable",
  data() {
    const data = []
    const groups = []
    const types = []
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    const states = [
      {
        id: true,
        name: "Активные"
      },
      {
        id: false,
        name: "Удаленные"
      }
    ]
    return {
      data: data,
      groups: groups,
      types: types,
      states: states,
      limits: limits,
      currentPage: 1,
      total: 0,
      filters: {
        type_id: null,
        group_id: null,
        is_active: null,
        order: 'asc',
        limit: 25
      },
    }
  },
  computed: {
    // 
  },
  mounted: function() {
    let $this = this
    
    this.$store.dispatch('getTypes')
      .then(response => {
        let data = response.data;

        data.data.forEach((item) => {
          this.types.push(item)
        })
      })
      .catch(error => {
        this.types = []
      });

    this.$store.dispatch('getGroups')
      .then(response => {
        let data = response.data;

        data.data.forEach((item) => {
          this.groups.push(item)
        })
      })
      .catch(error => {
        this.groups = []
      });

    this.$store.dispatch('getProducts')
      .then(response => {
        let data = response.data;
        $this.total = data.total

        data.data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })
    
    EventBus.$on('successCreateProduct', (data) => {
      this.data.push(data)
    })

    EventBus.$on('failedCreateProduct', (msg) => {
      this.$toast.open({
        message: `${this.$i18n.t('admin.create_error')} ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
    })
    
    EventBus.$on('successUpdateProduct', () => {
      $this.pageChange()
    })

  },
  beforeDestroy: function(){
    EventBus.$off('successCreateProduct')
    EventBus.$off('failedCreateProduct')
    EventBus.$off('successUpdateProduct')
  },
  methods: {
    editRow(item){
      EventBus.$emit("showModal", "product.edit", item)
    },
    showRow: function(item) {
      EventBus.$emit("showModal", "chart.view", item)
    },
    add(item){
      EventBus.$emit("showModal", "product.add", null)
    },
    dropRow(id) {
      let $this = this
      this.$dialog.confirm({
        message: $this.$i18n.t('admin.product_delete_message'),
        cancelText: $this.$i18n.t('admin.no'),
        confirmText: $this.$i18n.t('admin.yes'),
        onConfirm: () => {
          $this.$store.dispatch('deleteProduct', id)
          this.pageChange()
        }
      })
    },
    applyType(id){
      this.filters.type_id = id
      this.pageChange()
    },
    clearType(){
      this.filters.type_id = null
      this.pageChange()
    },
    applyGroup(id){
      this.filters.group_id = id
      this.pageChange()
    },
    clearGroup(){
      this.filters.group_id = null
      this.pageChange()
    },
    clearState(){
      this.filters.is_active = null
      this.pageChange()
    },
    humanGroup: function(value){
      let name = this.groups.filter(function(state) {
        return state.id === value;
      })
      .map(function(state) {
        return state.name;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return ""
      }
    },
    humanType: function(value){
      let name = this.types.filter(function(state) {
        return state.id === value;
      })
      .map(function(state) {
        return state.name;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return ""
      }
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
      this.$store.dispatch('getPageProducts', {page: this.currentPage, filters: this.filters})
        .then(response => {
          let data = response.data;
          
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })

        })
        .catch(error => {
          this.data = []
        })
    }
  }
}
</script>